import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { CustomerProvider, useCustomerData } from '../customerData';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { CustomerCarService } from 'src/services/customer/customerCarService';
import { DatePicker, DateTimePicker } from '@mui/lab';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import { useCustomerBookingCart } from '../selectedCustomerData';

function AddCustomerCar(props) {
  const { open, handleClose, onAddNewData, initialRows, data } = props;

  const dataModel = {                  
  carId: 0,
  carNickName: '',
  registrationNumber: '',  
  passingYear: 0,
  fuelTypeId: 0,
  engineNumber: '',       
  carColor: '',
  chassisNumber: '',       
  customerId: 0,
  isActive: true
};

  const { selectedCustomerData, handleGetCustomerCarById } =
    useCustomerBookingCart();

  const { allCars, customerfuelType, allBrands } = useCustomerData();
  const [newData, setNewData] = useState(dataModel);
  const [selectedCarId, setSelectedCarId] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [selectedCarsList, setSelectedCarsList] = useState([]);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);
  const [selectedFuelTypeId, setSelectedFuelTypeId] = useState('');
  const [selectedFuelTypeList, setSelectedFuelTypeList] = useState([]);

  const handleAddClose = () => {
    setNewData(dataModel);
    setSelectedCarId('');
    setSelectedFuelTypeId('');
    props.handleClose();
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedFuelTypeList(customerfuelType);

        setSelectedCarsList(allCars);
      } catch (error) {
        console.error('Error fetching data from the API:', error);
      }
    };
    fetchData();
  }, [open]);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });
     if (newData.carId && newData.registrationNumber) {
    setIsAddButtonDisabled(false);
  } else {
    setIsAddButtonDisabled(true);
  }
  };

  const handleAddNewData = () => {
    //   if (
    //     !newData.carId ||
    //     !newData.registrationNumber ||
    //     !newData.passingYear ||
    //     !newData.engineNumber ||
    //     !newData.carNickName
    //   ) {
    //     console.log(newData);
    //     enqueueSnackbar('Please fill in all mandatory fields', {
    //       variant: 'error'
    //     });
    //     return;
    //   }

    if (!newData.carId || !newData.registrationNumber) {
    enqueueSnackbar('Please select a car and enter registration number', {
      variant: 'error',
    });
    return;
  }

    newData.customerId = selectedCustomerData?.id || data?.id || 0;


    CustomerCarService.addData(newData)
      .then((data) => {
        handleGetCustomerCarById('Get');
      })
      .catch((error) => {
        console.error('Error updating data:', error);
      });

    handleAddClose();
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }

    return newData[fieldId] || '';
  };

  const allFields = [
    {
      id: 'carId',
      field: 'Select',
      title: 'Search Car*',
      selectedId: selectedCarId,
      dataList: selectedCarsList,
      function: setSelectedCarId,
      type: 'text',
      size: 12
    },
    {
      id: 'carNickName',
      field: 'textField',
      title: 'Car Nick Name',
      type: 'text',
      size: 12
    },
    {
      id: 'registrationNumber',
      field: 'textField',
      title: 'Registration Number*',
      type: 'text',
      size: 6
    },
    
    {
      id: 'passingYear',
      field: 'textField',
      title: 'Passing Year',
      type: 'text',
      size: 6
    },
    {
      id: 'fuelTypeId',
      field: 'Select',
      title: 'Fuel Type',
      type: 'text',
      selectedId: selectedFuelTypeId,
      dataList: selectedFuelTypeList,
      function: setSelectedFuelTypeId,
      size: 6
    },
    {
      id: 'engineNumber',
      field: 'textField',
      title: 'Engine Number',
      type: 'text',
      size: 6
    },
    {
      id: 'carColor',
      field: 'textField',
      title: 'Car Color',
      type: 'date',
      size: 6
    },
    {
      id: 'chassisNumber',
      field: 'textField',
      title: 'Chassic Number',
      type: 'date',
      size: 6
    },
    {
      id: 'isActive',
      field: 'status',
      // title: 'Status',
      type: 'text',
      size: 12
    }
  ];

  return (
    <>
      <Dialog open={open} onClose={handleAddClose} maxWidth="sm" fullWidth>
        <DialogTitle style={useStyles.dialogTitle}>{props.Label}</DialogTitle>
        <DialogContent style={useStyles.bodyStyle}>
          <Grid container spacing={2}>
            {allFields.map((field) => (
              <Grid item xs={field.size} key={field.id}>
                <Typography style={useStyles.formTitle}>
                  {field.title}
                </Typography>
                {field.field === 'textField' && (
                  <TextField
                    style={useStyles.formControl}
                    margin="dense"
                    id={field.id}
                    type="dateTime"
                    fullWidth
                    value={getFieldValue(field.id) || ''}
                    onChange={(e) => handleDataChange(field.id, e.target.value)}
                    key={`textfield-${field.id}`}
                  />
                )}
                {field.field === 'Select' && (
                  <Select
                    style={useStyles.formControl}
                    fullWidth
                    value={field.selectedId}
                    onChange={(e) => {
                      handleDataChange(field.id, e.target.value);
                      field.function(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled key={`${field.id}-empty`}>
                      <em>{field.type}</em>
                    </MenuItem>
                    {field.dataList.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {field.id === 'carId'
                          ? `${data.name}-${data.brand.name}`
                          : data.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {field.field === 'Date' && (
                  <div style={useStyles.formControl}>
                    <DatePicker
                      value={getFieldValue(field.id) || null}
                      onChange={(date) => handleDataChange(field.id, date)}
                      renderInput={(props) => <TextField {...props} />}
                    />
                  </div>
                )}
                {field.field === 'status' && (
                  <StatusSwitch
                    newData={newData}
                    handleSwitchChange={handleDataChange}
                    field={field.id}
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleAddNewData}
            color="primary"
            variant="contained"
          >
            {props.addBtn}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AddCustomerCar;
